import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  Box,
  FormControl,
  FormLabel,
  Typography,
  FormControlLabel,
  FormGroup,
  Checkbox,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  checkboxGroupTitle: {
    color: theme.palette.text.primary,
  },
  container: {
    containerType: 'inline-size',
    containerName: 'sizesWrapper',
  },
  cols: {
    columnCount: 1,
    columnFill: 'balance',
    '@container (min-width: 450px)': {
      columnCount: 2,
    },
    '@container (min-width: 700px)': {
      columnCount: 3,
    },
    '@container (min-width: 800px)': {
      columnCount: 4,
    },
  }
}));

const SuitableTyreSizes = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { allSizes = [], selectedSizes = [], handleChange, disabled } = props;
  const [rims, setRims] = React.useState({});

  const onChange = (event) => {
    const size = event.target.name;
    const isSelected = event.target.checked;
    const oldState = selectedSizes;
    let newState;

    if (isSelected) {
      // Add to list
      newState = [...oldState, size];
    } else {
      newState = oldState.filter((c) => c !== size);
    }

    handleChange(newState);
  };

  useEffect(() => {
    setRims(
      allSizes.reduce((acc, cur) => {
        if (cur.rim !== undefined && !acc[parseFloat(cur.rim)]) {
          acc[parseFloat(cur.rim)] = allSizes.filter((size) => size.rim === cur.rim);
        }
        return acc;
      }, {})
    );
  }, [allSizes]);

  return (
    <FormControl component="fieldset" fullWidth={true} className={classes.container}>
      <FormLabel component="legend">
        <Typography
          variant="h6"
          component="h2"
          className={classes.checkboxGroupTitle}
        >
          {t('suitableTyreSizes:suitableTyreSizes')}
        </Typography>
      </FormLabel>
      <Box
        p={3}
        border={1}
        borderColor="rgba(0, 0, 0, 0.1)"
        borderRadius={4}
        mt={3}
      >
        <FormGroup>
          {Object.keys(rims).sort(function(a, b){ return a - b; }).map((val) => (
            <Box mb={2} key={val}>
              <Typography variant="subtitle1" display="block">
                <strong>{val}&quot;</strong>
              </Typography>
              <div className={classes.cols}>
                {rims[val].map((size) => (
                  <div key={size.sizeString}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            selectedSizes.includes(size.sizeString) ? true : false
                          }
                          onChange={onChange}
                          name={size.sizeString}
                          color="primary"
                        />
                      }
                      label={size.sizeString}
                      disabled={disabled}
                    />
                  </div>
                ))}
              </div>
            </Box>
          ))}
        </FormGroup>
      </Box>
    </FormControl>
  );
};

SuitableTyreSizes.propTypes = {
  allSizes: PropTypes.array,
  selectedSizes: PropTypes.array,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SuitableTyreSizes;
